import React, { useEffect, useRef, useState } from "react";
import Header from "../../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../../Components/Dashboard/Sidebar/Sidebar";
import FloatingLabelInput from "../../../../Components/floatingLabel/FloatingLabel";
import "../ResumeDisplay/ResumeDisplay.css";
import { BiHomeAlt } from "react-icons/bi";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Apiurl, GetToken, RemoveUserSession } from "../../../../Utils/utils";
import axios from "axios";
import moment from "moment";
import Select from "react-select";
import Loader from "../../../../Components/loader/loader";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "./ResumeUploard.css";

const ResumeUploard = () => {
  const navigate = useNavigate();
  const [errorFirstName, setErrorFirstName] = useState(false);
  const [dummy, setDummy] = useState(false);
  const [errorEmergencyContactNumber, setErrorEmergencyContactNumber] =
    useState(false);
  const [errorMobile, setErrorMobile] = useState();
  const [errorEmail, setErrorEmail] = useState();
  const [errorCategory, setErrorCategory] = useState();
  const [errorSubCategory, setErrorSubCategory] = useState();
  const [errorSkills, setErrorSkills] = useState();
  const [errorPhoto, setErrorPhoto] = useState(false);
  const [errorAddress, setErrorAddress] = useState(false);
  const [newImageUrl, setNewImageUrl] = useState("");
  const [photoExtension, setPhotoExtension] = useState("");
  const fileInputRef = useRef(null);
  const [showSidebar, setShowSidebar] = useState(true);
  const [ProfileData, setProfileData] = useState("");
  const [loading, setLoading] = useState(false);
  const LoginToken = GetToken();
  const [departmentData, setDepartmentData] = useState([]);
  const [departmentId, setDepartmentId] = useState("");
  const [SubCategory, setSubCategoryy] = useState([]);
  const [expreinceeuserData, setExpreinceeuserData] = useState("");
  const [profileAlldata, setProfileAllData] = useState({
    FirstName: "",
    Email: "",
    Mobile: "",
    Category: "",
    SubCategory: "",
    Skills: "",
    Experience: "",
    UrlLink: "",
  });

  const location = useLocation();
  const PrefiledData = location?.state;
 

  useEffect(() => {
    if (PrefiledData) {
      setProfileAllData((prevProfileAllData) => ({
        ...prevProfileAllData,
        FirstName: PrefiledData?.Name,
        Email: PrefiledData?.Email,
        Mobile: PrefiledData?.Phone,
        Category: {
          label: PrefiledData?.Categories?.Name,
          value: PrefiledData?.Categories?.Id,
        },
        SubCategory: PrefiledData.SubCategories,
        Skills: PrefiledData?.Skills,
        UrlLink: PrefiledData?.DocumentPath,
        Experience: {
          label: PrefiledData.Experiences?.Name,
          value: PrefiledData.Experiences?.Id,
        },
      }));
      setDepartmentId(PrefiledData?.Categories?.Id);
    }
  }, [PrefiledData]);

  const validate = () => {
    if (!profileAlldata?.FirstName) {
      setErrorFirstName("userFirstName");
      return false;
    }

    if (!profileAlldata?.Mobile) {
      setErrorMobile("userMobile");
      return false;
    }

    if (!profileAlldata?.Email) {
      setErrorEmail("userEmail");
      return false;
    }
    if (!profileAlldata?.Category) {
      setErrorCategory("userCategory");
      return false;
    }
    if (!profileAlldata?.SubCategory) {
      setErrorSubCategory("userSubCategory");
      return false;
    }
    if (!profileAlldata?.Skills) {
      setErrorSkills("userSkills");
      return false;
    }
    return true;
  };

  // const GetProfile = () => {
  //   setLoading(true);
  //   const option = {
  //     method: "GET",
  //     headers: {
  //       "access-control-allow-origin": "*",
  //       "content-type": "application/json",
  //       authorization: `Bearer ${LoginToken}`,
  //     },
  //     url: `${Apiurl()}/Profile/GetProfile`,
  //   };
  //   axios(option)
  //     .then((e) => {
  //       const data = JSON.parse(e?.data?.data);
  //       setProfileData(data);
  //       const gender = Gender?.find((e) => e?.id === data?.Gender);
  //       setProfileAllData({
  //         ...profileAlldata,
  //         FirstName: data?.FirstName,
  //         LastName: data?.LastName,
  //         Email: data?.Email,
  //         Mobile: data?.Mobile?.slice(0, 10),
  //         DateOfBirth: data?.DateOfBirth,
  //         Gender: gender,
  //         Department: data?.Departments?.Name,
  //         Designation: data?.Designations?.DesignationName,
  //         Address: data?.Address,
  //         UrlLink: data?.UrlLink,
  //         Emergencycontactno: data?.Emergencycontactno,
  //         TeamLeads: data?.TeamLeads?.UserName,
  //       });
  //       setLoading(false);
  //     })
  //     .catch((error) => {
  //       if (
  //         error?.message === "Network Error" &&
  //         error?.code === "ERR_NETWORK"
  //       ) {
  //         toast.error("Your Session has been expired");
  //         RemoveUserSession();
  //         navigate("/");
  //       }
  //     });
  // };
  // useEffect(() => {
  //   GetProfile();
  // }, []);
  const handleImageChange = (e) => {
    // const file = e.target.files[0];
    // if (file) {
    //   const reader = new FileReader();
    //   reader.onloadend = () => {
    //     const base64Image = reader.result;
    //     setProfileAllData({
    //       ...profileAlldata,
    //       UrlLink: base64Image,
    //     });
    //     setNewImageUrl(base64Image);
    //   };
    //   reader.readAsDataURL(file);
    //   const photoExtension = file.type.split("/")[1];
    //   setPhotoExtension(photoExtension);
    // }
    const file = e.target.files[0];
    setFile(file);
  };

  const handleCancel = (e) => {
    setProfileAllData({
      FirstName: "",
      Email: "",
      Mobile: "",
      Category: "",
      SubCategory: "",
      Skills: "",
      UrlLink: "",
    });
  };
  const [file, setFile] = useState(null);
  const handleResumeUploard = () => {
    // if(!validate())return
    const formData = new FormData();

    if (PrefiledData) {
      // PrefiledData.Id;
      formData.append("Id", PrefiledData.Id);
      formData.append("Name", profileAlldata.FirstName);
      formData.append("Phone", profileAlldata.Mobile);
      formData.append("Email", profileAlldata.Email);
      formData.append("Category", profileAlldata.Category?.value);
      formData.append("SubCategory", profileAlldata.SubCategory?.Id);
      formData.append("Skills", profileAlldata.Skills);
      formData.append("Experience", profileAlldata?.Experience);
      formData.append("AttachmentDocument", file);
    } else {
      formData.append("Name", profileAlldata.FirstName);
      formData.append("Phone", profileAlldata.Mobile);
      formData.append("Email", profileAlldata.Email);
      formData.append("Category", profileAlldata.Category.value);
      formData.append("SubCategory", profileAlldata.SubCategory?.Id);
      formData.append("Experience", profileAlldata.Experience.Id);
      formData.append("Skills", profileAlldata.Skills);
      // formData.append('AttachmentDocument', newImageUrl);
      formData.append("AttachmentDocument", file);
    }
    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "Content-Type": "multipart/form-data",
        "access-control-allow-origin": "*",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `https://attendanceapi.elitewebdemo.com/api/Cv/SaveCv`,
      data: formData,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        if (e?.status === 200) {
          toast.success(e?.data?.message);
          navigate("/Emp/ResumeDisplay")
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => {
        setShowSidebar(false);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }
    setShowSidebar(true);
  }, []);

  const getDepartment = () => {
    setLoading(true);
    const token = GetToken();
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      url: `${Apiurl()}/Admin/GetDepartments`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        const data = JSON.parse(e?.data?.data);
        const finalData = data?.map((item) => ({
          label: item?.Name,
          value: item?.Id,
        }));
        setDepartmentData(finalData);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getDepartment();  
  }, []);
  const handleDepartmentChange = (selectedOption) => {
    setDepartmentId(selectedOption?.value);
    setProfileAllData({ ...profileAlldata, Category: selectedOption });
  };

  const SubDepartment = (e) => {
    e?.preventDefault();
    setLoading(true);
    const LoginToken = GetToken();
    const data = {};
    data.DepartmentId = departmentId;
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Admin/GetDesignations`,
      data: { data: JSON.stringify(data) },
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        const data = JSON.parse(e?.data?.data);
        setSubCategoryy(data);
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  useEffect(() => {
    if (departmentId) {
      SubDepartment();
    }
  }, [departmentId]);

  const handleDesignationData = (selectedOption) => {
    setProfileAllData({ ...profileAlldata, SubCategory: selectedOption });
    setDepartmentId(selectedOption?.value);
  };
  const handleUserExperiences = (selectedOption) => {
    setProfileAllData({ ...profileAlldata, Experience: selectedOption });
  };
  const GetUserExperiences = () => {
    setLoading(true);
    const token = GetToken();
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      url: `https://attendanceapi.elitewebdemo.com/api/Cv/GetExperiences`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        const data = JSON.parse(e?.data?.data);
        setExpreinceeuserData(data.Result);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  useEffect(() => {
    GetUserExperiences();
  }, []);
  return (
    <>
      {loading ? <Loader /> : null}
      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} dummy={dummy} setDummy={setDummy} />
        <section
          className={
            showSidebar
              ? "EMP-profile-main-section"
              : "EMP-profile-main-section-new"
          }
        >
          <div className="EMP-profile-all-icons">
            <div>
              <p className="Resume-Uploder-main-heading">Resume </p>
            </div>
            <div className="dashboiard-inner-header">
              <BiHomeAlt className="EMP-home-icon-header-inn" />
              <MdKeyboardArrowRight />
              <p> Resume </p>
              <MdKeyboardArrowRight />
              <p> Upload </p>
            </div>
          </div>
          <div className="EMP-Resume-main-container">
            <div className="EMP-Resume-outter-container">
              <div className="EMP-Resume-inner-container">
                <div className="EMP-profile-heading">
                  <p> Resume</p>
                </div>
                <div className="EMP-Resume-inner-box row">
                  {/* Name Field   */}
                  <div className="profile-inputs col-4">
                    <FloatingLabelInput
                      label="Name*"
                      value={profileAlldata?.FirstName}
                      onChange={(e) =>
                        setProfileAllData({
                          ...profileAlldata,
                          FirstName: e?.target?.value,
                        })
                      }
                      onBlur={(e) => {
                        if (!e?.target?.value) {
                          setErrorFirstName("userFirstName");
                        } else {
                          setErrorFirstName("false");
                        }
                      }}
                    />
                  </div>
                  {/* Phone Number Field  */}
                  <div className="profile-inputs col-4">
                    <FloatingLabelInput
                      label="Phone*"
                      maxLength="10"
                      value={profileAlldata.Mobile}
                      onChange={(e) => {
                        const inputMobile = e.target.value
                          .replace(/\D/g, "")
                          .slice(0, 10);
                        setProfileAllData({
                          ...profileAlldata,
                          Mobile: inputMobile,
                        });
                      }}
                      onBlur={(e) => {
                        if (!e?.target?.value) {
                          setErrorMobile("userMobile");
                        } else {
                          setErrorMobile("false");
                        }
                      }}
                    />
                  </div>
                  {/* Email Field  */}
                  <div className="profile-inputs col-4">
                    <FloatingLabelInput
                      label="Email*"
                      value={profileAlldata?.Email?.trim()}
                      onChange={(e) =>
                        setProfileAllData({
                          ...profileAlldata,
                          Email: e?.target?.value,
                        })
                      }
                      style={{ marginBottom: 0 }}
                      onBlur={(e) => {
                        if (!e?.target?.value) {
                          setErrorEmail("userEmail");
                        } else {
                          setErrorEmail("false");
                        }
                      }}
                    />
                  </div>
                  <div className="profile-inputs col-6">
                    <Select
                      classNamePrefix="prefix-department-forCv-screen"
                      placeholder="Category"
                      options={departmentData}
                      getOptionLabel={(option) => option?.label}
                      getOptionValue={(option) => option?.value}
                      value={
                        profileAlldata?.Category
                          ? {
                              value: profileAlldata?.Category?.value,
                              label: departmentData.find(
                                (item) =>
                                  item?.value ===
                                  profileAlldata?.Category?.value
                              )?.label,
                            }
                          : null
                      }
                      onChange={handleDepartmentChange}
                    />
                  </div>

                  <div className="profile-inputs col-6">
                    <Select
                      classNamePrefix="subdepartment-dropdown-forCv-Screen"
                      placeholder="Sub Categories"
                      options={SubCategory}
                      getOptionLabel={(option) => option?.DesignationName}
                      getOptionValue={(option) => option?.Id}
                      onChange={handleDesignationData}
                    />
                  </div>

                  <div className="profile-inputs col-6">
                    <FloatingLabelInput
                      label="Skills*"
                      value={profileAlldata.Skills}
                      onChange={(e) =>
                        setProfileAllData({
                          ...profileAlldata,
                          Skills: e?.target?.value,
                        })
                      }
                      onBlur={(e) => {
                        if (!e?.target?.value) {
                          setErrorSkills("userSkills");
                        } else {
                          setErrorSkills("false");
                        }
                      }}
                    />
                  </div>
                  <div className="profile-inputs col-6">
                    <Select
                      classNamePrefix="subdepartment-dropdown-forCv-Screen"
                      placeholder="Experiences "
                      options={expreinceeuserData}
                      value={profileAlldata.Experience}
                      getOptionLabel={(options) => options?.Name}
                      getOptionValue={(options) => options?.Id}
                      onChange={handleUserExperiences}
                    />
                  </div>

                  <div className="Resume-uploder-container col-6">
                    <label htmlFor="profileImage">CV Upload</label>
                    <div className="CV-Upload-Container">
                      <input
                        type="file"
                        id="profileImage"
                        ref={fileInputRef}
                        onChange={handleImageChange}
                      />
                    </div>
                  </div>

                  <div className="Addemployee-buttons">
                    <button
                      className="Resume-uploder-screen-sumbit-button"
                      onClick={() => handleResumeUploard("update")}
                    >
                      {/* Submit */}
                      {PrefiledData ? "Update" : "submit"}
                    </button>

                    <button
                      className="Resume-uploder-screen-Cancel-button"
                      onClick={() => handleCancel()}
                    >
                      {" "}
                      Cancel{" "}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
export default ResumeUploard;
